module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-5.6dd56c13.svg";